import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Lightweight opt-in for anyone who has already pre-registered (identified via their
// own referral_code in localStorage) to get a heads-up the moment Ambassador perks launch.
export const PerksNotifyToggle = () => {
  const [referralCode, setReferralCode] = useState(null);
  const [optedIn, setOptedIn] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setReferralCode(localStorage.getItem("rr_referral_code"));
    setOptedIn(localStorage.getItem("rr_perks_notify_opted_in") === "true");
  }, []);

  if (!referralCode) return null;

  const handleToggle = async (checked) => {
    setSaving(true);
    try {
      await axios.patch(`${API}/leads/referral/${referralCode}/perks-notify`, { opted_in: checked });
      setOptedIn(checked);
      localStorage.setItem("rr_perks_notify_opted_in", String(checked));
      toast.success(checked ? "🔔 You're in! We'll notify you the moment perks launch." : "Notifications turned off.");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      data-testid="perks-notify-toggle"
      className="mt-6 inline-flex items-center gap-3 bg-white/10 border border-white/15 rounded-full pl-5 pr-2 py-2.5"
    >
      <Bell size={15} className="text-rr-orangeLight shrink-0" />
      <span className="text-xs md:text-sm font-semibold text-white whitespace-nowrap">Notify me about perks</span>
      <Switch checked={optedIn} onCheckedChange={handleToggle} disabled={saving} data-testid="perks-notify-switch" />
    </div>
  );
};
